/**
 * ClinicianHomeRedirect.jsx — where a ChartMind clinician lands after sign-in.
 * Shaped by: Prompt 27; D-21-04.
 * Invariants: ClinicalHUD2 only when the grant is known. Denied and error
 *   both fail closed to the Apps launcher. Never the retired page.
 *   A forced error is display-only and emulator-only.
 * Related: useClinicalHudAccess.js, RetiredChartMindRoute.jsx, useIjwForcedState.js.
 */
import React from "react";
import { Box, Typography } from "@mui/material";
import { Navigate } from "react-router-dom";
import Loading from "components/Loading";
import useClinicalHudAccess from "features/clinicalHud/app/hooks/useClinicalHudAccess";
import { useIjwForcedState } from "components/ijw/useIjwForcedState";

export default function ClinicianHomeRedirect() {
  const { canAccess, loading, error } = useClinicalHudAccess();
  const forced = useIjwForcedState("clinician-home");

  if (loading && forced !== "error") {
    return <Loading page />;
  }

  // Prompt 27: an access-check error is not "no access" and is not a grant.
  // The forced error exists only so the click-through can prove fail-closed.
  const failedClosed = Boolean(error) || forced === "error";
  if (!failedClosed && canAccess) {
    return <Navigate to="/clinical-hud-2" replace />;
  }

  return (
    <Box
      data-testid="clinician.home.apps"
      sx={{ p: 3, maxWidth: 480 }}
    >
      <Typography variant="h5">Apps</Typography>
      <Typography color="text.secondary">
        Open Apps in the top bar to choose a tool.
      </Typography>
    </Box>
  );
}
